import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@rebass/grid';

const BrenntagImprint = () => {
    const {t} = useTranslation();

    return <Box>
        <p>
            Brenntag Holding GmbH<br />
            Messeallee 11<br />
            45131 Essen<br />
            <br />
            <b>{t("PHONE")}:</b> +49 201 6496-0<br />
            <b>{t("EMAIL")}:</b> infobrenntag@brenntag.de<br />
            <br />
            <b>{t("MANAGIN_DIRECTORS")}:</b> Dr. Christian Kohlpaintner, Georg Müller, Henri Nejade, Steven Terwindt<br />
            <br />
            <b>{t("REGISTERED_DOMICILE")}:</b> Essen<br />
            <b>{t("DISTRICT_COURT")}:</b> Essen HRB 28683<br />
            <br />
            <b>{t("VAT_NUMBER")}:</b> DE814733420
        </p>
    </Box>
}

export default BrenntagImprint
